import { render, staticRenderFns } from "./OnboardingStepperForm.vue?vue&type=template&id=cae4930a&scoped=true&"
import script from "./OnboardingStepperForm.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepperForm.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingStepperForm.vue?vue&type=style&index=0&id=cae4930a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae4930a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib'
installComponents(component, {VForm})
